import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { ViewComponent } from './view.component';

const ROUTES:Routes = [
  {
    path: '',
    component: ViewComponent,
  },
];

@NgModule({ imports: [
  CommonModule,
  FormsModule,
  RouterModule.forChild(ROUTES),
],
declarations: [ViewComponent],
exports: [ViewComponent] })

export class ViewModule { }
